import React from 'react'
import { joinChannel, partChannel } from 'api/Api'

const _channels = {}

const addChannel = (channel, onError) => {
  if (_channels[channel]) {
    _channels[channel] += 1
  } else {
    _channels[channel] = 1
    const joinPromise = joinChannel(channel)

    joinPromise.catch(error => {
      delete _channels[channel]

      onError && onError(error)
    })
  }
}

const removeChannel = (channel) => {
  if (_channels[channel]) {
    if (_channels[channel] > 1) {
      _channels[channel] -= 1
    } else {
      delete _channels[channel]
      partChannel(channel)
    }
  }
}

export default React.createContext({
  addChannel,
  removeChannel
})
